module.exports = __webpack_public_path__ + "img/binzhou-people-government.88100cad.png";